/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AppConfig } from '../models/app-config';
import { findAppConfigByName } from '../fn/admin-app-configs/find-app-config-by-name';
import { FindAppConfigByName$Params } from '../fn/admin-app-configs/find-app-config-by-name';
import { updateAppConfigByName } from '../fn/admin-app-configs/update-app-config-by-name';
import { UpdateAppConfigByName$Params } from '../fn/admin-app-configs/update-app-config-by-name';
import { uploadAppConfigLogo } from '../fn/admin-app-configs/upload-app-config-logo';
import { UploadAppConfigLogo$Params } from '../fn/admin-app-configs/upload-app-config-logo';

@Injectable({ providedIn: 'root' })
export class AdminAppConfigsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminAppConfigControllerFindAppConfigByName()` */
  static readonly AdminAppConfigControllerFindAppConfigByNamePath = '/admin/app-configs/{name}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAppConfigByName()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAppConfigByName$Response(
    params: FindAppConfigByName$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<AppConfig>> {
    return findAppConfigByName(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAppConfigByName$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAppConfigByName(params: FindAppConfigByName$Params, context?: HttpContext): Observable<AppConfig> {
    return this.findAppConfigByName$Response(params, context).pipe(
      map((r: StrictHttpResponse<AppConfig>): AppConfig => r.body)
    );
  }

  /** Path part for operation `adminAppConfigControllerUpdateAppConfigByName()` */
  static readonly AdminAppConfigControllerUpdateAppConfigByNamePath = '/admin/app-configs/{name}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAppConfigByName()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAppConfigByName$Response(
    params: UpdateAppConfigByName$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<AppConfig>> {
    return updateAppConfigByName(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAppConfigByName$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAppConfigByName(params: UpdateAppConfigByName$Params, context?: HttpContext): Observable<AppConfig> {
    return this.updateAppConfigByName$Response(params, context).pipe(
      map((r: StrictHttpResponse<AppConfig>): AppConfig => r.body)
    );
  }

  /** Path part for operation `adminAppConfigControllerUploadAppConfigLogo()` */
  static readonly AdminAppConfigControllerUploadAppConfigLogoPath = '/admin/app-configs/logo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadAppConfigLogo()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadAppConfigLogo$Response(
    params: UploadAppConfigLogo$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<AppConfig>> {
    return uploadAppConfigLogo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadAppConfigLogo$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadAppConfigLogo(params: UploadAppConfigLogo$Params, context?: HttpContext): Observable<AppConfig> {
    return this.uploadAppConfigLogo$Response(params, context).pipe(
      map((r: StrictHttpResponse<AppConfig>): AppConfig => r.body)
    );
  }
}
